import { useRequestGetAuditLogs } from '@/hooks/httpRequest';
import { useQueryParams } from '@/hooks';
import { useCallback, useEffect } from 'react';
import { AuditLogActionEnum, AuditLogEntityTypeEnum } from '@/enums';

const ALL_ACTIONS = Object.values(AuditLogActionEnum);
const ALL_ENTITY_TYPES = Object.values(AuditLogEntityTypeEnum);

const useAuditLogs = () => {
	const {
		values: [from, to, page, limit],
		urlSearchParams,
		updateSearchParams,
		setValues
	} = useQueryParams(['from', 'to', 'page', 'limit']);

	useEffect(() => {
		if (!urlSearchParams.has('action') || !urlSearchParams.has('entityType')) {
			updateSearchParams(params => {
				if (!urlSearchParams.has('action')) {
					for (const a of ALL_ACTIONS) params.append('action', a);
				}
				if (!urlSearchParams.has('entityType')) {
					for (const et of ALL_ENTITY_TYPES) params.append('entityType', et);
				}
				return params;
			});
		}
	}, [urlSearchParams, updateSearchParams]);

	const parseMultiValues = useCallback((key: string) => {
		return urlSearchParams.getAll(key);
	}, [urlSearchParams]);

	const parsedActions = parseMultiValues('action') as AuditLogActionEnum[];
	const parsedEntityTypes = parseMultiValues('entityType') as AuditLogEntityTypeEnum[];

	const result = useRequestGetAuditLogs({
		action: parsedActions.length > 0 ? parsedActions : undefined,
		entityType: parsedEntityTypes.length === 1 ? parsedEntityTypes[0] : undefined,
		from: from as string | undefined,
		to: to as string | undefined,
		page,
		limit
	});

	return {
		...result,
		urlSearchParams,
		parsedActions,
		parsedEntityTypes,
		from: from as string | undefined,
		to: to as string | undefined,
		setValues
	};
};

export default useAuditLogs;
